export default "__VITE_ASSET__DNQHEwRn__"